import axios from 'axios'
import wrappers from '../utils/wrappers'
import type { EditorSettings } from '../types/editor'
import type { IUserAssets, PublicProfile, PublicProfilePatchParams } from '../types/users'

const url = `${import.meta.env.VITE_API_URL}/v1/users`

export default {
  get(userId: string) {
    return axios
      .get(`${url}/${userId}`, { timeout: 5000 })
      .then((response: any) => wrappers.handleEscribonautaResponse(response))
  },

  patch(userId: string, params: { editorSettings?: EditorSettings }) {
    return axios
      .patch(`${url}/${userId}`, params, { timeout: 5000 })
      .then((response: any) => wrappers.handleEscribonautaResponse(response))
  },

  patchEditorSettings(userId: string, editorSettings: Partial<EditorSettings>) {
    return axios
      .patch(`${url}/${userId}/editor-settings`, { editorSettings }, { timeout: 5000 })
      .then((response: any) => wrappers.handleEscribonautaResponse(response))
      .catch((error: any) =>
        wrappers.handleEscribonautaError(error, 'No se pudieron editar los ajustes del editor'),
      )
  },

  patchProfile(userId: string, params: { assets?: IUserAssets }) {
    return axios
      .patch(`${url}/${userId}/profile`, params, { timeout: 5000 })
      .then((response: any) => wrappers.handleEscribonautaResponse(response))
      .catch((error: any) =>
        wrappers.handleEscribonautaError(error, 'No se pudo actualizar el perfil'),
      )
  },

  publicPatch(params: PublicProfilePatchParams) {
    return axios
      .patch(`${url}/me/public`, params, { timeout: 5000 })
      .then((response: any) => wrappers.handleEscribonautaResponse(response) as {
        data: {
          publicVisibility: PublicProfile['publicVisibility']
          publicInfo: PublicProfile['publicInfo']
          publicAppearance: PublicProfile['publicAppearance']
          socialMedia: PublicProfile['socialMedia']
        }
      })
      .catch((error: any) =>
        wrappers.handleEscribonautaError(error, 'No se pudo actualizar el perfil público'),
      )
  },

  getByPublicAlias(publicAlias: string) {
    return axios
      .get(`${url}/public/${encodeURIComponent(publicAlias)}`, { timeout: 10000 })
      .then((response: any) => (
        wrappers.handleEscribonautaResponse(response) as { data: PublicProfile }
      ))
  },

  getAssetDownloadUrl(userId: string, assetKey: string) {
    return axios
      .get(`${url}/${userId}/assets/${assetKey}/download-url`, { timeout: 5000 })
      .then((response: any) => wrappers.handleEscribonautaResponse(response))
      .catch((error: any) =>
        wrappers.handleEscribonautaError(error, 'No se pudo obtener la imagen completa'),
      )
  },
}
